import { render, staticRenderFns } from "./customizationGPTsMobile.vue?vue&type=template&id=5d578f46&scoped=true"
import script from "./customizationGPTsMobile.vue?vue&type=script&lang=js"
export * from "./customizationGPTsMobile.vue?vue&type=script&lang=js"
import style0 from "./customizationGPTsMobile.vue?vue&type=style&index=0&id=5d578f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d578f46",
  null
  
)

export default component.exports